import { useState, type ReactNode } from 'react';

import { api } from '../../api';
import { Campo, Painel } from '../../comum';
import type { EtapaTeste } from '../../tipos';
import type { PropsSecao } from './comum';

/**
 * Conta de serviço da sincronização.
 *
 * ⚠️ Não é a conta com que a pessoa entra no produto — essa é a dela, validada
 * pelo próprio appliance. Confundir as duas já custou uma conta bloqueada.
 */
export function SecaoKace({ c, podeEditar, acao, salvar }: PropsSecao): ReactNode {
  const [kace, setKace] = useState({ ...c.kace, senha: '' });
  const [testeKace, setTesteKace] = useState<readonly EtapaTeste[] | null>(null);

  return (
    <Painel
      titulo="Conexão com o KACE"
      sub="Conta de serviço usada pela sincronização. Não é a conta com que você entra — essa é a sua."
    >
      <div className="grade2">
        <Campo rotulo="Endereço do appliance" ajuda="Só o host, sem caminho e sem barra final.">
          <input
            value={kace.baseUrl}
            disabled={!podeEditar}
            onChange={(e) => setKace({ ...kace, baseUrl: e.target.value })}
          />
        </Campo>
        <Campo rotulo="Organização" ajuda="Com o prefixo numérico, exatamente como no KACE.">
          <input
            value={kace.organizacao}
            disabled={!podeEditar}
            onChange={(e) => setKace({ ...kace, organizacao: e.target.value })}
          />
        </Campo>
        <Campo rotulo="Usuário">
          <input
            value={kace.usuario}
            disabled={!podeEditar}
            onChange={(e) => setKace({ ...kace, usuario: e.target.value })}
          />
        </Campo>
        <Campo
          rotulo="Senha"
          ajuda={
            c.kace.senhaDefinida
              ? 'Já existe uma senha gravada. Deixe em branco para mantê-la.'
              : 'Nenhuma senha gravada.'
          }
        >
          <input
            type="password"
            value={kace.senha}
            disabled={!podeEditar}
            placeholder={c.kace.senhaDefinida ? '••••••••' : ''}
            onChange={(e) => setKace({ ...kace, senha: e.target.value })}
          />
        </Campo>
      </div>

      <div className="linha">
        <button
          className="encolhe"
          disabled={acao.executando || !podeEditar}
          onClick={() =>
            void acao.rodar(async () => {
              const r = await api.post<{
                ok: boolean;
                etapas: readonly EtapaTeste[];
              }>('/api/config/kace/testar', kace);
              setTesteKace(r.etapas);
              return null;
            })
          }
        >
          Testar conexão
        </button>
        <button
          className="primario encolhe"
          disabled={acao.executando || !podeEditar}
          onClick={() => salvar('kace', kace, 'Conexão com o KACE')}
        >
          Salvar
        </button>
        <span className="cresce" />
      </div>

      {testeKace !== null && (
        <ul className="passos">
          {testeKace.map((e) => (
            <li key={e.etapa}>
              <span className="marca-passo">{e.ok ? '✓' : '✗'}</span>
              <span style={e.ok ? {} : { color: 'var(--erro)' }}>{e.detalhe}</span>
            </li>
          ))}
        </ul>
      )}
    </Painel>
  );
}
